import { createContext, useContext, type ReactNode } from "react";

import { EMPTY_CREATE_APPLICATION_DICTIONARIES, type CreateApplicationDictionaries } from "./create-application-dictionaries.lib";
import { useCreateApplicationDictionaries } from "./hooks/use-create-application-dictionaries";

type CreateApplicationDictionariesContextValue = {
  dictionaries: CreateApplicationDictionaries;
  isLoading: boolean;
  isError: boolean;
};

const CreateApplicationDictionariesContext = createContext<CreateApplicationDictionariesContextValue>({
  dictionaries: EMPTY_CREATE_APPLICATION_DICTIONARIES,
  isLoading: true,
  isError: false,
});

export const CreateApplicationDictionariesProvider = ({ children }: { children: ReactNode }) => {
  const value = useCreateApplicationDictionaries();

  return <CreateApplicationDictionariesContext.Provider value={value}>{children}</CreateApplicationDictionariesContext.Provider>;
};

export const useCreateApplicationDictionariesContext = () => useContext(CreateApplicationDictionariesContext);
